import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import Upload from './input/Upload'

const CardUpload = (props) => {
  let { formControls, handleChange, handleRemoveFile } = props

  return (
    <div className="c-personalizer-card">
      
      <div className="c-personalizer-card__header">
        <h3 className="c-personalizer-card__title">3. Opdruk toevoegen</h3>
      </div>
      
      <div class="c-personalizer-row">
        <p class="c-personalizer-row__explain">Voeg je logo of afbeelding toe. Indien de afbeelding niet goed uitkomt of van onvoldoende kwaliteit is nemen wij direct contact op.</p>
        <Upload name="file" 
          value={formControls.file.value}
          onChange={handleChange}
          touched={formControls.file.touched}
          valid={formControls.file.valid}
          accept={formControls.file.accept}
          onRemoveFile={handleRemoveFile}
          error={formControls.file.error}
          fileName={formControls.file.fileName}
        />
        <p class="c-personalizer-row__notice">Geen opdruk bij de hand? Je mag deze ook later opsturen.</p>
      </div>


    </div>
  )
}

export default CardUpload



// WEBPACK FOOTER //
// ./src/js/personalizer/components/CardUpload.js